import { AnyAction, Reducer } from 'redux'
import {
  SetLanguageAction,
  LocalizationState,
  TranslationStack
} from './types'
import { LANGUAGE_SET } from './actionTypes'

const localization = (
  initialState: LocalizationState,
  translations: TranslationStack
): Reducer => (
  state: LocalizationState = initialState,
  action: SetLanguageAction | AnyAction
): LocalizationState => {

  if(action.type === LANGUAGE_SET) {
    const { language } = action

    return {
      ...state,
      current: language,
      translations: translations[language]
    }
  }

  return state

}

export default localization
